import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { GetUserWithRole } from "../../services/incentive";
import { addFollowUpUser, GetAllFolloUpUser } from "../../services/followUpService";

import CommonMessage from "../../common/CommonMessage";
import CDropdown from "../../common/CDropdown";

import ViewFollowUpUser from "./ViewFollowUpUser";
import TeleCaller from "./TeleCaller";

const INITIAL_VALUES = {
    userId: "",
};

const AddFollowUpUser = () => {
    const navigate = useNavigate();

    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [formData, setFormData] = useState(INITIAL_VALUES);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!formData.userId) {
            setSelectedUsers([]);
            return;
        }

        loadAssignedUsers(formData.userId);
    }, [formData.userId]);

    const loadAssignedUsers = async (userId) => {
    try {
        const response = await GetAllFolloUpUser(userId);
console.log("GetAllFolloUpUser",response.data);
        if (response?.success) {
            //const ids = response.data.map(x => Number(x.assignId));
            const ids = response.data
                .filter(item => item.isActive)
                .map(item => Number(item.assignId));
            setSelectedUsers(ids);
        } else {
            setSelectedUsers([]);
        }
    } catch (err) {
        console.log(err);
        setSelectedUsers([]);
    }
};

useEffect(() => {
    console.log("selectedUsers:", selectedUsers);
}, [selectedUsers]);


    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        try {
            const response = await GetUserWithRole();
//console.log("follo",response);
            if (response?.success) {
                const teamLeaders = (response.data ?? []).filter(user =>
                    user.name.includes("(Team Leader)")
                );

                setUsers(teamLeaders);
            } else {
                setErrors({
                    form: response?.message || "Failed to load users."
                });
            }
        } catch (error) {
            console.log(error);

            setErrors({
                form: "Something went wrong while loading users."
            });
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: "",
            selectedUsers: ""
        }));

        setMessage("");
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.userId) {
            newErrors.userId = "Please select a user.";
        }

        if (selectedUsers.length === 0) {
            newErrors.selectedUsers =
                "Please select at least one follow-up user.";
        }

        if (selectedUsers.includes(Number(formData.userId))) {
    newErrors.selectedUsers =
        "Parent user cannot be selected as follow-up user.";
}
        //  {
        //     newErrors.selectedUsers =
        //         "Parent user cannot be selected as follow-up user.";
        // }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            setLoading(true);

            const payload = {
    userId: Number(formData.userId),
    assignUsers: selectedUsers.map((id) => ({
        assignId: Number(id),
    })),
};

            const response = await addFollowUpUser(payload);

            if (response?.success) {
                setMessage("Follow-up users added successfully.");

                setFormData(INITIAL_VALUES);
                setSelectedUsers([]);
                setErrors({});
            } else {
                setMessage(response?.message || "Failed to save.");
            }
        } catch (error) {
            console.error(error);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-4">

            <div className="row justify-content-center">

                <div className="col-lg-10">

                    <div className="card border-0 shadow-lg rounded-4">

                        <div className="card-header bg-primary text-white rounded-top-4 py-3">
                            <h4 className="mb-0 fw-bold">
                                Add Follow Up User
                            </h4>
                        </div>

                        <div className="card-body p-4">

                            {message && (
                                <div className="mb-3">
                                    <CommonMessage text={message} />
                                </div>
                            )}

                            {errors.form && (
                                <div className="alert alert-danger">
                                    {errors.form}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>

                                <div className="row g-4">

                                    <div className="col-md-6">
                                        <CDropdown
                                            label="Select User"
                                            name="userId"
                                            value={formData.userId}
                                            options={users}
                                            optionLabel="name"
                                            optionValue="id"
                                            firstOption="Select User"
                                            onChange={handleChange}
                                            error={errors.userId}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold">
                                            Select Follow-Up Users
                                        </label>

                                        <TeleCaller
                                            selectedUsers={selectedUsers}
                                            setSelectedUsers={setSelectedUsers}
                                        />

                                        {errors.selectedUsers && (
                                            <small className="text-danger">
                                                {errors.selectedUsers}
                                            </small>
                                        )}
                                    </div>

                                </div>

                                <hr className="my-4" />

                                <div className="d-flex justify-content-end gap-2">

                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary px-4"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-success px-4"
                                        disabled={loading}
                                    >
                                        {loading
                                            ? "Submitting..."
                                            : "Save Follow-Up User"}
                                    </button>

                                </div>

                            </form>

                        </div>

                    </div>

                </div>

            </div>

            {formData.userId && (

                <div className="row justify-content-center mt-4">

                    <div className="col-lg-10">

                        <div className="card shadow-sm border-0 rounded-4">

                            <div className="card-header bg-light">
                                <h5 className="mb-0 fw-bold">
                                    Assigned Follow-Up Users
                                </h5>
                            </div>

                            <div className="card-body">

                                <ViewFollowUpUser
                                    userId={Number(formData.userId)}
                                />

                            </div>

                        </div>

                    </div>

                </div>

            )}

        </div>
    );
};

export default AddFollowUpUser;